export type CanvasCollectionStateType = {
  data: Canvas[] | null;
  loading: boolean;
  error: string | null;
};

export type CanvasDetailStateType = {
  data: Canvas | null;
  loading: boolean;
  submitting: boolean;
  error: string | null;
};

export type CanvasBackgroundCollectinStateType = {
  data: CanvasBackground[] | null;
  loading: boolean;
  error: string | null;
};

export type CanvasStateType = {
  collection: CanvasCollectionStateType;
  detail: CanvasDetailStateType;
  backgroundCollection: CanvasBackgroundCollectinStateType;
};

export const CANVAS = 'canvas';
export type CANVAS = typeof CANVAS;
